
import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, ChevronRight } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-grandpal-green-dark text-white pt-16 pb-8">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Column 1 - Logo and About */}
          <div>
            <img src="/logo-white.svg" alt="Grandpal" className="h-10 mb-6" onError={e => {
            e.currentTarget.src = '/placeholder.svg';
            e.currentTarget.alt = 'Grandpal';
            e.currentTarget.className = 'h-10 mb-6 invert';
          }} />
            <p className="text-grandpal-green-light mb-6">
              Helping families navigate nursing home care in Ireland with compassion and expertise.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/grandpal.co" aria-label="Facebook" className="hover:text-grandpal-orange transition-colors duration-200">
                <Facebook size={20} />
              </a>
              <a href="https://x.com/grandpalco" aria-label="Twitter" className="hover:text-grandpal-orange transition-colors duration-200">
                <Twitter size={20} />
              </a>
              <a href="https://www.instagram.com/grandpal.co" aria-label="Instagram" className="hover:text-grandpal-orange transition-colors duration-200">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com/company/grandpal" aria-label="LinkedIn" className="hover:text-grandpal-orange transition-colors duration-200">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-xl mb-6 font-bold">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/nursing-homes" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Nursing Homes</span>
                </Link>
              </li>
              <li>
                <Link to="/guides" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Fair Deal Guide</span>
                </Link>
              </li>
              <li>
                <Link to="/blog" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Blog</span>
                </Link>
              </li>
              <li>
                <Link to="/about" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/careers" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Careers</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Popular Counties */}
          <div>
            <h3 className="text-xl mb-6 font-bold">Popular Counties</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/nursing-homes/dublin" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Dublin</span>
                </Link>
              </li>
              <li>
                <Link to="/nursing-homes/cork" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Cork</span>
                </Link>
              </li>
              <li>
                <Link to="/nursing-homes/galway" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Galway</span>
                </Link>
              </li>
              <li>
                <Link to="/nursing-homes/kildare" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Kildare</span>
                </Link>
              </li>
              <li>
                <Link to="/nursing-homes" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>View All Counties</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Legal */}
          <div>
            <h3 className="text-xl mb-6 font-bold">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/legal/privacy-policy" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Privacy Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/legal/terms-of-use" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Terms of Use</span>
                </Link>
              </li>
              <li>
                <Link to="/legal/cookie-policy" className="flex items-center hover:text-grandpal-orange transition-colors duration-200">
                  <ChevronRight size={16} className="mr-1" />
                  <span>Cookie Policy</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-grandpal-green-light/30 mt-12 pt-8 text-center md:text-left md:flex md:justify-between md:items-center">
          <p className="text-grandpal-green-light">
            © {currentYear} Grandpal. All rights reserved.
          </p>
          <p className="text-grandpal-green-light mt-4 md:mt-0">
            Made with ♥ in Ireland
          </p>
        </div>
      </div>
    </footer>;
}
